import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { accountInitial, getDemoAccount, roleLabel } from '../admin-prototype/account';
import { buyerInquiries, ipListings, ipSaleApplications } from '../admin-prototype/mock-data';

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  --brand-950: #0b2f22;
  --brand-900: #0d3a29;
  --brand-800: #115537;
  --brand-700: #19723f;
  --brand-600: #248b4b;
  --brand-100: #dcf3e3;
  --brand-50: #f0faf3;
  --market-800: #075f70;
  --market-700: #08788a;
  --market-100: #d8f2f5;
  --market-50: #eefbfc;
  --ink-950: #0b1410;
  --ink-800: #24332b;
  --ink-600: #55645c;
  --ink-500: #728078;
  --line: #dce5df;
  display: block;
  min-height: 100%;
  color: var(--ink-950);
}

.dashboard-shell,
.dashboard-shell * {
  box-sizing: border-box;
}

.dashboard-shell {
  position: relative;
  isolation: isolate;
  min-height: 100dvh;
  overflow-x: hidden;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0, rgba(248, 251, 249, 0.98) 28%, #f3f7f4 100%);
}

.dashboard-glow {
  position: fixed;
  z-index: -1;
  border-radius: 999px;
  filter: blur(2px);
  pointer-events: none;
}

.dashboard-glow--management {
  top: 92px;
  left: -190px;
  width: 480px;
  height: 480px;
  opacity: 0.68;
  background: radial-gradient(circle, rgba(36, 139, 75, 0.11), rgba(36, 139, 75, 0) 70%);
}

.dashboard-glow--market {
  right: -180px;
  bottom: -130px;
  width: 460px;
  height: 460px;
  opacity: 0.62;
  background: radial-gradient(circle, rgba(8, 120, 138, 0.1), rgba(8, 120, 138, 0) 70%);
}

.dashboard-container {
  width: min(1160px, 100% - 48px);
  margin-right: auto;
  margin-left: auto;
}

.dashboard-header {
  position: relative;
  z-index: 20;
  height: 76px;
  border-bottom: 1px solid rgba(17, 85, 55, 0.1);
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 4px 20px rgba(11, 47, 34, 0.025);
  -webkit-backdrop-filter: blur(18px);
  backdrop-filter: blur(18px);
  animation: headerReveal 520ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.dashboard-header__inner {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.dashboard-brand {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 14px;
}

.dashboard-brand__surface {
  display: inline-flex;
  height: 46px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
}

.dashboard-brand__logo {
  display: block;
  width: auto;
  height: 37px;
  object-fit: contain;
}

.dashboard-brand__divider {
  width: 1px;
  height: 28px;
  flex: 0 0 auto;
  background: #dbe4de;
}

.dashboard-brand__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
  white-space: nowrap;
}

.dashboard-brand__copy strong {
  color: #304038;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.15em;
}

.dashboard-brand__copy small {
  color: #8a9690;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.dashboard-header__actions {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.header-account {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
  padding: 7px 12px;
  border: 1px solid #e2e9e4;
  border-radius: 12px;
  background: rgba(247, 250, 248, 0.9);
}

.header-account__status {
  position: relative;
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #35a95c;
  box-shadow: 0 0 0 4px rgba(53, 169, 92, 0.1);
}

.header-account__status::after {
  position: absolute;
  inset: -5px;
  border: 1px solid rgba(53, 169, 92, 0.35);
  border-radius: inherit;
  content: "";
  animation: statusPulse 2.4s ease-out infinite;
}

.header-account__copy {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.header-account__copy strong {
  overflow: hidden;
  max-width: 120px;
  color: #26362d;
  font-size: 12px;
  font-weight: 800;
  text-overflow: ellipsis;
}

.header-account__copy span {
  padding-left: 8px;
  border-left: 1px solid #dce5df;
  color: #7b8981;
  font-size: 10px;
  font-weight: 600;
}

.logout-button {
  display: inline-flex;
  min-width: 88px;
  height: 42px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border: 1px solid #dce5df;
  border-radius: 12px;
  outline: none;
  color: #55645c;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(11, 47, 34, 0.035);
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  transition: color 180ms ease, border-color 180ms ease, background 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.logout-button svg {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
}

.logout-button:hover {
  border-color: #c9d6ce;
  color: var(--brand-800);
  background: #f8fbf9;
  box-shadow: 0 6px 14px rgba(11, 47, 34, 0.07);
  transform: translateY(-1px);
}

.logout-button:active {
  transform: translateY(0);
}

.logout-button:focus-visible {
  border-color: var(--brand-600);
  box-shadow: 0 0 0 4px rgba(36, 139, 75, 0.14);
}

.dashboard-main {
  position: relative;
  z-index: 1;
  min-height: calc(100dvh - 76px);
  padding: 0 0 20px;
}

.dashboard-content {
  display: flex;
  min-height: calc(100dvh - 120px);
  flex-direction: column;
}

.insight-hero {
  position: relative;
  display: flex;
  width: 100vw;
  min-height: 300px;
  margin-left: calc(50% - 50vw);
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border-top: 1px solid rgba(25, 114, 63, 0.12);
  border-bottom: 1px solid rgba(25, 114, 63, 0.14);
  background-color: #f3faf6;
  background-image: url("/assets/dashboard-hero-ip-insight.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0 16px 38px rgba(11, 47, 34, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.72);
  animation: riseReveal 600ms 70ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.insight-hero::before {
  position: absolute;
  z-index: 1;
  inset: 0;
  background: linear-gradient(90deg, rgba(246, 252, 248, 0.98) 0%, rgba(246, 252, 248, 0.92) 34%, rgba(246, 252, 248, 0.38) 55%, rgba(246, 252, 248, 0) 72%);
  content: "";
  pointer-events: none;
}

.insight-hero__copy {
  position: relative;
  z-index: 2;
  display: flex;
  width: min(1160px, 100% - 48px);
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 36px 0 32px;
  text-align: left;
}

.dashboard-kicker {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin: 0 0 12px;
  color: var(--brand-700);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.dashboard-kicker__dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--brand-600);
  box-shadow: 0 0 0 5px rgba(36, 139, 75, 0.09);
}

.insight-hero h1 {
  margin: 0;
  max-width: 610px;
  color: var(--ink-950);
  font-size: clamp(36px, 3.2vw, 46px);
  font-weight: 780;
  line-height: 1.16;
  letter-spacing: -0.045em;
  word-break: keep-all;
}

.insight-hero h1 span,
.insight-hero h1 strong {
  display: block;
}

.insight-hero h1 strong {
  margin-top: 3px;
  color: var(--brand-700);
  font-weight: 850;
}

.insight-hero__description {
  max-width: 560px;
  margin: 14px 0 0;
  color: var(--ink-600);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.65;
  word-break: keep-all;
}

.insight-hero__actions {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 20px;
}

.insight-primary,
.insight-secondary {
  display: inline-flex;
  height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  outline: none;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  transition: color 180ms ease, background 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.insight-primary {
  min-width: 124px;
  padding: 0 14px;
  border-radius: 12px;
  color: #ffffff;
  background: var(--brand-700);
  box-shadow: 0 9px 20px rgba(25, 114, 63, 0.18);
}

.insight-secondary {
  min-width: 108px;
  padding: 0 5px;
  color: var(--brand-700);
}

.insight-primary svg {
  width: 15px;
  height: 15px;
  transition: transform 180ms ease;
}

.insight-secondary svg {
  width: 15px;
  height: 15px;
  transition: transform 180ms ease;
}

.insight-primary:hover,
.insight-secondary:hover {
  transform: translateY(-1px);
}

.insight-primary:hover {
  color: #ffffff;
  background: var(--brand-800);
  box-shadow: 0 12px 24px rgba(25, 114, 63, 0.22);
}

.insight-primary:hover svg,
.insight-secondary:hover svg {
  transform: translateX(3px);
}

.insight-primary:focus-visible,
.insight-secondary:focus-visible {
  box-shadow: 0 0 0 4px rgba(36, 139, 75, 0.16);
}

.insight-status {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 8px;
  margin-top: 13px;
  padding: 0 11px;
  border: 1px solid rgba(25, 114, 63, 0.16);
  border-radius: 999px;
  color: #4e6658;
  background: rgba(255, 255, 255, 0.78);
  font-size: 9px;
  font-weight: 700;
  white-space: nowrap;
}

.insight-status__dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #35a95c;
  box-shadow: 0 0 0 4px rgba(53, 169, 92, 0.1);
}

.console-grid {
  display: grid;
  margin-top: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.console-card {
  --accent: var(--brand-700);
  --accent-dark: var(--brand-800);
  --accent-soft: var(--brand-50);
  --accent-line: #bfe5ca;
  --accent-wash: rgba(36, 139, 75, 0.08);
  position: relative;
  display: block;
  min-width: 0;
  min-height: 300px;
  overflow: hidden;
  padding: 23px 25px 22px;
  border: 1px solid var(--accent-line);
  border-radius: 24px;
  outline: none;
  color: inherit;
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.99) 0%, rgba(255, 255, 255, 0.97) 58%, var(--accent-soft) 100%);
  box-shadow: 0 12px 30px rgba(11, 47, 34, 0.055), inset 0 1px 0 rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: border-color 240ms ease, box-shadow 240ms ease, transform 240ms cubic-bezier(0.22, 1, 0.36, 1);
  animation: cardReveal 620ms 160ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.console-card--market {
  --accent: var(--market-700);
  --accent-dark: var(--market-800);
  --accent-soft: var(--market-50);
  --accent-line: #b9e6ec;
  --accent-wash: rgba(8, 120, 138, 0.075);
  animation-delay: 260ms;
}

.console-card__accent {
  position: absolute;
  top: 0;
  right: 48px;
  left: 48px;
  height: 3px;
  border-radius: 0 0 999px 999px;
  opacity: 0.82;
  background: linear-gradient(90deg, transparent, var(--accent), transparent);
  pointer-events: none;
}

.console-card__orbit {
  position: absolute;
  border: 1px solid var(--accent-wash);
  border-radius: 999px;
  pointer-events: none;
  transition: transform 500ms cubic-bezier(0.22, 1, 0.36, 1);
}

.console-card__orbit--one {
  top: -92px;
  right: -66px;
  width: 230px;
  height: 230px;
  box-shadow: 0 0 0 28px rgba(255, 255, 255, 0.22);
}

.console-card__orbit--two {
  right: 36px;
  bottom: -72px;
  width: 132px;
  height: 132px;
}

.console-card__content {
  position: relative;
  z-index: 1;
  display: flex;
  min-height: 254px;
  flex-direction: column;
}

.console-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.console-badge {
  display: inline-flex;
  height: 30px;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid var(--accent-line);
  border-radius: 999px;
  color: var(--accent-dark);
  background: rgba(255, 255, 255, 0.72);
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.console-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--accent);
  box-shadow: 0 0 0 4px var(--accent-wash);
}

.console-index {
  color: var(--accent);
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.console-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 18px;
}

.console-icon {
  display: inline-flex;
  width: 50px;
  height: 50px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--accent-line);
  border-radius: 15px;
  color: var(--accent);
  background: var(--accent-soft);
  box-shadow: 0 7px 18px var(--accent-wash);
  transition: color 220ms ease, background 220ms ease, transform 240ms cubic-bezier(0.22, 1, 0.36, 1);
}

.console-icon svg {
  width: 24px;
  height: 24px;
}

.console-heading__eyebrow {
  margin: 0 0 4px;
  color: #89968f;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.13em;
}

.console-heading h2 {
  margin: 0;
  color: var(--ink-950);
  font-size: 27px;
  font-weight: 850;
  line-height: 1.2;
  letter-spacing: -0.035em;
}

.console-description {
  max-width: 92%;
  min-height: 36px;
  margin: 12px 0 0;
  color: var(--ink-600);
  font-size: 12px;
  line-height: 1.7;
  word-break: keep-all;
}

.console-metrics {
  display: grid;
  margin: 15px 0 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.console-metric {
  min-width: 0;
  padding: 11px 12px 10px;
  border: 1px solid rgba(220, 229, 223, 0.85);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
  transition: border-color 220ms ease, background 220ms ease, transform 220ms ease;
}

.console-metric dt {
  overflow: hidden;
  margin: 0;
  color: #7b8981;
  font-size: 9px;
  font-weight: 650;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.console-metric dd {
  margin: 5px 0 0;
  color: var(--ink-950);
  font-size: 17px;
  font-weight: 850;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.console-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: auto;
  padding-top: 17px;
  border-top: 1px solid rgba(211, 223, 216, 0.78);
}

.console-route {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
  color: #78867e;
  font-size: 9px;
  font-weight: 650;
  white-space: nowrap;
}

.console-route svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  color: var(--accent);
}

.console-cta {
  display: inline-flex;
  min-width: 92px;
  height: 36px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 11px;
  border-radius: 11px;
  color: #ffffff;
  background: var(--accent);
  box-shadow: 0 8px 18px var(--accent-wash);
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
  transition: background 200ms ease, box-shadow 200ms ease, transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.console-cta svg {
  width: 16px;
  height: 16px;
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.console-card:focus-visible {
  border-color: var(--accent);
  box-shadow: 0 0 0 4px var(--accent-wash), 0 18px 40px rgba(11, 47, 34, 0.1);
}

.account-panel {
  display: flex;
  min-width: 0;
  min-height: 86px;
  align-items: center;
  gap: 24px;
  margin-top: 18px;
  padding: 14px 21px;
  border: 1px solid var(--line);
  border-radius: 19px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 9px 25px rgba(11, 47, 34, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.9);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  animation: riseReveal 560ms 390ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.account-profile {
  display: flex;
  min-width: 260px;
  align-items: center;
  gap: 13px;
}

.account-avatar {
  position: relative;
  display: inline-flex;
  width: 48px;
  height: 48px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #cfe3d5;
  border-radius: 15px;
  color: var(--brand-800);
  background: linear-gradient(145deg, #f4fbf6, #e8f6ec);
  box-shadow: 0 7px 16px rgba(25, 114, 63, 0.09);
  font-size: 14px;
  font-weight: 900;
}

.account-avatar__status {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 12px;
  height: 12px;
  border: 3px solid #ffffff;
  border-radius: 999px;
  background: #35a95c;
}

.account-identity {
  min-width: 0;
}

.account-identity p {
  margin: 0 0 3px;
  color: var(--brand-700);
  font-size: 8px;
  font-weight: 850;
  letter-spacing: 0.13em;
}

.account-identity h2 {
  overflow: hidden;
  margin: 0;
  color: var(--ink-950);
  font-size: 14px;
  font-weight: 850;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-identity > span {
  display: block;
  overflow-wrap: anywhere;
  margin-top: 2px;
  color: var(--ink-500);
  font-size: 10px;
  line-height: 1.35;
}

.account-divider {
  width: 1px;
  height: 45px;
  flex: 0 0 auto;
  background: #e2e9e4;
}

.account-details {
  display: grid;
  min-width: 280px;
  margin: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 26px;
}

.account-details div {
  min-width: 0;
}

.account-details dt {
  margin: 0;
  color: #89958e;
  font-size: 9px;
  font-weight: 650;
}

.account-details dd {
  overflow: hidden;
  margin: 5px 0 0;
  color: #304038;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-access {
  display: flex;
  min-width: 250px;
  align-items: center;
  gap: 11px;
  margin-left: auto;
  padding: 11px 13px;
  border: 1px solid #d9eadf;
  border-radius: 13px;
  background: var(--brand-50);
}

.account-access__icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: var(--brand-700);
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(25, 114, 63, 0.07);
}

.account-access__icon svg {
  width: 18px;
  height: 18px;
}

.account-access__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.account-access__copy strong {
  color: var(--brand-800);
  font-size: 10px;
  font-weight: 850;
  white-space: nowrap;
}

.account-access__copy small {
  color: #62816c;
  font-size: 8px;
  font-weight: 600;
  white-space: nowrap;
}

.dashboard-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 16px;
  color: #9aa59f;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
  animation: riseReveal 500ms 470ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.dashboard-footer span:last-child {
  letter-spacing: -0.01em;
}

@media (hover: hover) and (pointer: fine) {
  .console-card:hover {
    border-color: var(--accent);
    box-shadow: 0 22px 48px rgba(11, 47, 34, 0.105), inset 0 1px 0 rgba(255, 255, 255, 0.85);
    transform: translateY(-5px);
  }
  .console-card:hover .console-icon {
    color: #ffffff;
    background: var(--accent);
    transform: translateY(-2px) rotate(-2deg);
  }
  .console-card:hover .console-card__orbit--one {
    transform: translate(-8px, 8px) scale(1.03);
  }
  .console-card:hover .console-card__orbit--two {
    transform: translate(-5px, -7px) scale(0.96);
  }
  .console-card:hover .console-metric {
    border-color: var(--accent-line);
    background: rgba(255, 255, 255, 0.92);
    transform: translateY(-1px);
  }
  .console-card:hover .console-cta {
    background: var(--accent-dark);
    box-shadow: 0 11px 22px var(--accent-wash);
  }
  .console-card:hover .console-cta svg {
    transform: translateX(4px);
  }
}
.console-card:active {
  transform: translateY(-1px) scale(0.997);
}

@keyframes headerReveal {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes riseReveal {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes cardReveal {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.992);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes statusPulse {
  0% {
    opacity: 0.72;
    transform: scale(0.68);
  }
  75%, 100% {
    opacity: 0;
    transform: scale(1.55);
  }
}
@media (max-width: 1040px) {
  .dashboard-container {
    width: min(1160px, 100% - 40px);
  }
  .insight-hero {
    min-height: 294px;
    background-position: 54% center;
  }
  .account-panel {
    gap: 18px;
  }
  .account-profile {
    min-width: 220px;
  }
  .account-details {
    min-width: 230px;
    gap: 18px;
  }
  .account-access {
    min-width: 220px;
  }
}
@media (max-width: 900px) {
  .insight-hero {
    min-height: 300px;
    background-position: 58% center;
  }
  .console-grid {
    grid-template-columns: 1fr;
  }
  .console-card {
    min-height: 308px;
  }
  .account-panel {
    flex-wrap: wrap;
  }
  .account-divider {
    display: none;
  }
  .account-profile {
    flex: 1 1 280px;
  }
  .account-details {
    flex: 1 1 260px;
  }
  .account-access {
    flex: 1 1 100%;
    margin-left: 0;
  }
}
@media (max-width: 700px) {
  .dashboard-header {
    height: 68px;
  }
  .dashboard-main {
    min-height: calc(100dvh - 68px);
    padding-top: 0;
  }
  .dashboard-content {
    min-height: auto;
  }
  .dashboard-brand__surface {
    height: 42px;
  }
  .dashboard-brand__logo {
    height: 34px;
  }
  .dashboard-brand__divider {
    height: 24px;
  }
  .dashboard-brand__copy small {
    display: none;
  }
  .header-account__copy span {
    display: none;
  }
  .insight-hero h1 {
    font-size: clamp(29px, 7vw, 36px);
  }
  .insight-hero h1 span,
  .insight-hero h1 strong {
    display: block;
  }
  .insight-hero h1 strong {
    margin: 3px 0 0;
  }
  .insight-hero__description {
    font-size: 12px;
  }
  .insight-hero__copy {
    width: min(680px, 100% - 48px);
  }
  .insight-hero::before {
    background: linear-gradient(90deg, rgba(246, 252, 248, 0.98) 0%, rgba(246, 252, 248, 0.94) 52%, rgba(246, 252, 248, 0.65) 76%, rgba(246, 252, 248, 0.42) 100%);
  }
  .console-card {
    padding-right: 23px;
    padding-left: 23px;
    border-radius: 21px;
  }
  .account-panel {
    padding: 17px;
  }
}
@media (max-width: 520px) {
  .dashboard-container {
    width: calc(100% - 30px);
  }
  .dashboard-header__inner {
    gap: 12px;
  }
  .dashboard-brand {
    gap: 0;
  }
  .dashboard-brand__divider,
  .dashboard-brand__copy {
    display: none;
  }
  .dashboard-header__actions {
    gap: 7px;
  }
  .header-account {
    padding: 7px 9px;
  }
  .header-account__copy strong {
    max-width: 64px;
    font-size: 10px;
  }
  .logout-button {
    width: 42px;
    min-width: 42px;
    height: 42px;
    padding: 0;
  }
  .logout-button span {
    display: none;
  }
  .dashboard-main {
    padding-top: 0;
    padding-bottom: 18px;
  }
  .dashboard-kicker {
    font-size: 9px;
    letter-spacing: 0.12em;
  }
  .insight-hero {
    min-height: 332px;
    background-position: 64% center;
  }
  .insight-hero__copy {
    width: calc(100% - 32px);
    padding: 28px 0 26px;
  }
  .insight-hero__actions {
    width: 100%;
    flex-direction: column;
    gap: 10px;
  }
  .insight-primary,
  .insight-secondary {
    width: min(240px, 100%);
  }
  .insight-secondary {
    border: 1px solid rgba(25, 114, 63, 0.28);
    border-radius: 999px;
  }
  .insight-status {
    white-space: normal;
  }
  .console-grid {
    margin-top: 16px;
  }
  .console-card {
    min-height: 330px;
    padding: 22px 20px 20px;
  }
  .console-card__content {
    min-height: 286px;
  }
  .console-heading {
    margin-top: 19px;
  }
  .console-icon {
    width: 46px;
    height: 46px;
  }
  .console-heading h2 {
    font-size: 24px;
  }
  .console-description {
    max-width: 100%;
    min-height: 0;
    font-size: 11px;
  }
  .console-metrics {
    gap: 6px;
  }
  .console-metric {
    padding: 9px 8px;
  }
  .console-metric dt {
    min-height: 26px;
    overflow: visible;
    font-size: 8px;
    line-height: 1.45;
    text-overflow: clip;
    white-space: normal;
    word-break: keep-all;
  }
  .console-metric dd {
    margin-top: 3px;
    font-size: 15px;
  }
  .console-route {
    display: none;
  }
  .console-cta {
    width: 100%;
  }
  .account-profile,
  .account-details {
    flex-basis: 100%;
    min-width: 0;
  }
  .account-details {
    padding-top: 15px;
    border-top: 1px solid #e2e9e4;
  }
  .account-access {
    min-width: 0;
  }
  .account-access__copy strong,
  .account-access__copy small {
    white-space: normal;
  }
  .dashboard-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}
@media (max-height: 760px) and (min-width: 901px) {
  .dashboard-main {
    padding-top: 28px;
  }
  .console-grid {
    margin-top: 22px;
  }
  .console-card {
    min-height: 306px;
    padding-top: 23px;
    padding-bottom: 21px;
  }
  .console-card__content {
    min-height: 262px;
  }
  .console-heading {
    margin-top: 17px;
  }
  .console-description {
    margin-top: 10px;
  }
  .console-metrics {
    margin-top: 14px;
  }
  .account-panel {
    min-height: 86px;
    margin-top: 17px;
    padding-top: 14px;
    padding-bottom: 14px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dashboard-shell *,
  .dashboard-shell *::before,
  .dashboard-shell *::after {
    scroll-behavior: auto !important;
    animation: none !important;
    transition: none !important;
  }
  .console-card:hover,
  .console-card:active,
  .logout-button:hover {
    transform: none !important;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public account = getDemoAccount();
    public consoles: any[] = [];
    public managementOverview: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.account = getDemoAccount(this.service.auth.context);
        await this.loadManagementOverview();
        this.refresh();
        await this.service.render();
    }

    private async loadManagementOverview() {
        try {
            const response = await wiz.call('management_overview');
            const payload = response?.responseJSON || response;
            const status = Number(payload?.code ?? response?.status ?? 500);
            if (status >= 400) throw new Error('회원사 현황 조회 실패');
            this.managementOverview = payload?.data || null;
        } catch (_error) {
            this.managementOverview = null;
        }
    }

    public refresh() {
        const waitingApplications = ipSaleApplications.filter((item) => item.status === '검수대기');
        const activeListings = ipListings.filter((item) => item.status !== '비공개');
        const waitingBuyers = buyerInquiries.filter((item) => item.status === '접수');
        const managementValue = (key: string) => this.managementOverview
            ? `${Number(this.managementOverview[key] || 0)}곳`
            : '확인 불가';

        this.consoles = [
            {
                title: 'IP 관리',
                badge: 'MANAGEMENT',
                tone: 'management',
                route: '/management',
                description: '회원사 계약, 안내 및 견적 발송, 상담과 문의 응대를 관리합니다.',
                metrics: [
                    { label: '등록 회원사', value: managementValue('total') },
                    { label: '정상 개통', value: managementValue('active') },
                    { label: '개통/관리 필요', value: managementValue('not_active') }
                ]
            },
            {
                title: 'IP 거래',
                badge: 'TRANSACTION',
                tone: 'market',
                route: '/transaction',
                description: '판매검수, 공개매물 운영, 구매상담과 상담대기를 관리합니다.',
                metrics: [
                    { label: '검수대기', value: `${waitingApplications.length}건` },
                    { label: '공개매물', value: `${activeListings.length}건` },
                    { label: '상담대기', value: `${waitingBuyers.length}건` }
                ]
            }
        ];
    }

    public initial() {
        return accountInitial(this.account);
    }

    public roleName() {
        return roleLabel(this.account.role);
    }
}

export default PageDashboardComponent;